import { render, staticRenderFns } from "./PrepareToSendModal.vue?vue&type=template&id=089f94a6&scoped=true"
import script from "./PrepareToSendModal.vue?vue&type=script&lang=js"
export * from "./PrepareToSendModal.vue?vue&type=script&lang=js"
import style0 from "./PrepareToSendModal.vue?vue&type=style&index=0&id=089f94a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089f94a6",
  null
  
)

export default component.exports